module.exports = __webpack_public_path__ + "static/media/user-image.f5009b8c.jpg";